<dms-table [tableConfig]="tableConfig" [tableData]="tableData" (selectedRow)="rowSelected($event)" tableType="unit" #unitTable>
</dms-table>